












import { Component, Prop, Vue } from 'vue-property-decorator';
import { NetworkDomain } from '@/types';
import { networkSvc, merchantSvc } from '@/services';
import UpTags from '@/components/Common/UpTags.vue';

@Component({
  name: 'network-domains',
  components: { UpTags }
})
export default class NetworkDomains extends Vue {
  @Prop({ type: Array, required: true, default: () => [] })
  private domains!: NetworkDomain[];

  @Prop({ required: true })
  private networkId!: number;

  isLoading: Boolean = false;

  async removeDomain(domain: NetworkDomain) {
    this.isLoading = true;
    try {
      let result = await networkSvc.deleteNetworkDomain(domain.id as number);
      this.domains.splice(this.domains.indexOf(domain), 1);
    } catch (e) {
      // intentionally left blank
    }
    this.isLoading = false;
  }

  async addDomain(domain: string) {
    this.isLoading = true;
    try {
      let domainModel = await networkSvc.createNetworkDomain({
        domain,
        affiliate_network_id: this.networkId
      });
      this.domains.push(domainModel);
    } catch (e) {
      // intentionally left blank
    }
    this.isLoading = false;
  }
}
